import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { loadFeaturedLocations } from './utils';

export default function* listenLoadFeaturedLocations() {
  yield takeEvery(homeActions.loadFeaturedLocations.toString(), loadFeaturedLocations);
}
